/* unplugin-vue-components disabled */
export default {
  props: {
    href: {type: String, required: true}
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close () {
      this.$refs.modal.close()
    },
    async submit() {
      this.close()
      $utils.openLink(/^https?:\/\//i.test(this.href) ? this.href : `https://${this.href}`)
    }
  }
}
